'use client'

import React from 'react'
import dynamic from 'next/dynamic'

import type { MapBlock as MapBlockProps } from '@/payload-types'

// Lazy-load the Map component since it loads Google Maps API
// and is only used on contact/about pages
const MapBlockClient = dynamic(
  () => import('./Component.client').then((mod) => mod.MapBlockClient),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-screen md:h-[50vh] bg-neutral-100 animate-pulse" />
    ),
  },
)

export const MapBlock: React.FC<MapBlockProps> = (props) => {
  return <MapBlockClient {...props} />
}
